import gql from 'graphql-tag';

const GET_ONE = gql`
  query GetJabatan($id: ID!) {
    jabatanById(id: $id) {
      id
      nama
      atasanIds
      bawahanIds
      sejajarIds
    }
  }
`;

const GET_ALL = gql`
  query all($perPage: Int!, $page: Int, $where: JabatanWhereWhereConditions){
    jabatan(first: $perPage, page: $page, where: $where){
      data {
        id
        uuid
        nama
      },
      paginatorInfo {
        count
        total
        hasMorePages
        currentPage
        lastPage
        perPage
      }
    }
  }
`;

const GET_DETAIL = gql `
    query find($id: String!){
        jabatanByUuid(uuid : $id){
            id,
            uuid,
            nama,
            atasan_id,
            bidang_id,
            bidang{
              id
              uuid
              nama
            }
            atasan{
              id
              uuid
              nama
            }
            lower{
              id
              uuid
              nama
              pengguna{
                id
                nama
              }
            },
            pengguna{
              id
              uuid
              nama
              avatar
              jabatan{
                id
                nama
              }
            },
        }
    }
`;

const GET_COUNT_JABATAN_DISPOSISI = gql`
  query GetUserDisposition($userId: ID!){
    penggunaGetTargetDisposisiCount(userId: $userId) {
      atasanCount
      bawahanCount
      sejajarCount
    }
  }
`;

const GET_USER_BY_DISPOSISI_JABATAN = gql`
  query GetUserAtasan($perPage: Int!, $userId: ID!, $disposisiJabatan: String!) {
    penggunaGetByJabatanDisposisi(
      first: $perPage
      disposisiJabatan: $disposisiJabatan 
      userId: $userId
      orderBy: { field: NAMA, order: ASC }
    ) {
      data {
        id
        nama
        jabatan {
          id
          nama
        }
      }
    }
  }
`

const CREATE = gql `
    mutation($input:JabatanCreateInput!){
        jabatanCreate(input:$input){
            id,
            uuid,
            nama
        }
    }
`

const UPDATE = gql `
    mutation($id: ID!, $input:JabatanUpdateInput!){
        jabatanUpdate(id:$id, input:$input){
            id
            uuid
            nama
        }
    }
`

const DELETE = gql `
  mutation jabatanDelete($id: ID!){
    jabatanDelete(id: $id){
      uuid
    }
  }
`

export { 
  GET_ONE, 
  GET_COUNT_JABATAN_DISPOSISI, 
  GET_USER_BY_DISPOSISI_JABATAN, 
  GET_ALL, 
  GET_DETAIL,
  CREATE,
  UPDATE,
  DELETE
};
